import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'flatpickr/dist/flatpickr.min.css';
import './styles/App.css';


import Header from './components/Header';
import StepIndicator from './components/StepIndicator';
import Step1Form from './components/Step1Form';
import Step2Tnc from './components/Step2Tnc';
import Step3Booking from './components/Step3Booking';
import ModalPsikologDetail from './components/ModalPsikologDetail';

import BookingDetailPage from './pages/BookingDetailPage';
import LoginPage from './pages/LoginPage';

function MainApp() {
  const [currentStep, setCurrentStep] = useState(1);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState({
    kodePeserta: '',
    noPeserta: '',
    agreeTnc1: false,
    agreeTnc2: false,
    agreeAll: false,
    date: '',
    bahasa: '',
    name: ''
  });

  const [psikologData, setPsikologData] = useState([]);
  // const [bookingData, setBookingData] = useState(null);


  const nextStep = () => {
    setCurrentStep(prev => prev + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const prevStep = () => {
    setCurrentStep(prev => prev - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <Router>
      <Routes>
        {/* LOGIN */}
        <Route path="/login" element={<LoginPage />} />

        {/* BOOKING DETAIL */}
        <Route path="/booking-detail" element={<BookingDetailPage />} />

        {/* BOOKING FLOW */}
        <Route
          path="/"
          element={
            <div className="app-container">
              <Header />

              <div className="container mt-5 pt-5">
                <div className="booking-card p-3">
                  <StepIndicator currentStep={currentStep} />

                  <div className="p-0 p-md-4">
                    {currentStep === 1 && (
                      <Step1Form
                        formData={formData}
                        handleInputChange={handleInputChange}
                        nextStep={nextStep}
                      />
                    )}

                    {currentStep === 2 && (
                      <Step2Tnc
                        formData={formData}
                        handleInputChange={handleInputChange}
                        prevStep={prevStep}
                        nextStep={nextStep}
                        setPsikologData={setPsikologData}
                      />
                    )}

                    {currentStep === 3 && (
                      <Step3Booking
                        psikologData={psikologData}
                        prevStep={prevStep}
                        setShowModal={setShowModal}
                      />
                    )}
                  </div>
                </div>
              </div>

              {/* <ModalPsikologDetail
                show={showModal}
                onHide={() => setShowModal(false)}
                  psikolog={bookingData?.psikolog}
              /> */}
            </div>
          }
        />

        {/* FALLBACK */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default MainApp;
